import { Component, OnInit } from '@angular/core'
import { IRole, IRolePermission, RoleODataService } from '@exchange/domain/.'

@Component({
  selector: 'app-permissions-view',
  templateUrl: './permissions-view.component.html',
  standalone: false
})
export class PermissionsViewComponent implements OnInit {
  roles: IRole[] = []
  permissions: IRolePermission[] = []

  constructor(private roleService: RoleODataService) {}

  ngOnInit() {
    this.getRoles()
    this.getPermissions()
  }

  getRoles() {
    this.roleService
      .query()
      .orderBy('Name')
      .exec()
      .subscribe(response => {
        this.roles = response.data as IRole[]
      })
  }

  getPermissions() {
    this.roleService.customFunction(null, 'Default.GetAllPermissions').subscribe(response => {
      this.permissions = response.value as IRolePermission[]
    })
  }

  isRoleInPermission(role: string, permission: IRolePermission): boolean {
    return permission.Roles.indexOf(role) > -1
  }
}
